import Vue from 'vue';
import VueRouter from 'vue-router';
import { noAuthOnly, requireAuth } from '../utils/auth';
// import store from '../store/modules/auth';
import Home from '../views/Home.vue';
import NotFound from '../views/NotFound.vue';
import Role from '../views/owner/Role.vue';
import Logs from '../views/owner/Logs.vue';
import Requests from '../views/owner/Requests.vue';
import Alerts from '../views/owner/Alerts.vue';
import Pricing from '../views/owner/Pricing.vue';
// import Company from '../views/admin/Company.vue';

Vue.use(VueRouter);

const routes = [
  { path: '/404', component: NotFound },
  { path: '*', redirect: '/404' },
  {
    meta: {
      title: 'Login'
    },
    path: '/login',
    name: 'Login',
    beforeEnter: noAuthOnly,
    component: () => import(/* webpackChunkName: "login" */ '../views/Login.vue')
  },
  {
    meta: {
      title: 'ForgetPassword'
    },
    path: '/forget-password',
    name: 'ForgetPassword',
    beforeEnter: noAuthOnly,
    component: () => import(/* webpackChunkName: "login" */ '../views/ForgetPassword.vue')
  },
  {
    meta: {
      title: 'ResetPassword'
    },
    path: '/reset-password',
    name: 'ResetPassword',
    beforeEnter: noAuthOnly,
    component: () => import(/* webpackChunkName: "login" */ '../views/ResetPassword.vue')
  },
  {
    meta: {
      title: 'Logout'
    },
    path: '/logout',
    name: 'Logout',
    beforeEnter: requireAuth,
    component: () => import(/* webpackChunkName: "logout" */ '../views/Logout.vue')
  },
  {
    meta: {
      title: 'Comapny'
    },
    path: '/admin/company',
    name: 'Company',
    beforeEnter: requireAuth,
    component: () => import(/* webpackChunkName: "logout" */ '../views/admin/Company.vue')
  },
  {
    meta: {
      title: 'ComapnyDetails'
    },
    path: '/admin/company/:id',
    name: 'CompanyDetails',
    beforeEnter: requireAuth,
    component: () => import(/* webpackChunkName: "logout" */ '../views/admin/CompanyDetails.vue')
  },
  {
    meta: {
      title: 'FacilityDetails'
    },
    path: '/admin/facility/:id',
    name: 'FacilityDetails',
    beforeEnter: requireAuth,
    component: () => import(/* webpackChunkName: "logout" */ '../views/admin/FacilityDetails.vue')
  },
  {
    // Document title tag
    // We combine it with defaultDocumentTitle set in `src/main.js` on router.afterEach hook
    meta: {
      title: 'Dashboard'
    },
    path: '/',
    name: 'Dashboard',
    component: Home,
    beforeEnter: requireAuth,
    meta: { adminAuth: true }
  },
  {
    meta: {
      title: 'Owner'
    },
    path: '/owner/functions',
    name: 'Role',
    component: Role,
    beforeEnter: requireAuth,
    meta: { adminAuth: true }
  },
  {
    meta: {
      title: 'Owner'
    },
    path: '/owner/logs',
    name: 'Logs',
    component: Logs,
    beforeEnter: requireAuth,
    meta: { adminAuth: true }
  },
  {
    meta: {
      title: 'Owner'
    },
    path: '/owner/requests',
    name: 'Requests',
    component: Requests,
    beforeEnter: requireAuth,
    meta: { adminAuth: true }
  },
  {
    meta: {
      title: 'Owner'
    },
    path: '/owner/alerts',
    name: 'Alerts',
    component: Alerts,
    beforeEnter: requireAuth,
    meta: { adminAuth: true }
  },
  {
    meta: {
      title: 'Owner'
    },
    path: '/owner/pricing',
    name: 'Pricing',
    component: Pricing,
    beforeEnter: requireAuth,
    meta: { adminAuth: true }
  }
  // {
  //   meta: {
  //     title: 'Admin'
  //   },
  //   path: '/admin/company',
  //   name: 'Company',
  //   component: Company,
  //   beforeEnter: requireAuth,
  //   meta: { adminAuth: true }
  // }
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    let position = { x: 0, y: 0 };
    if (savedPosition) {
      position = savedPosition;
    } else if (to.hash) {
      position.selector = to.hash;
    }
    return new Promise(resolve => {
      setTimeout(() => {
        resolve(position);
      }, 500);
    });
  }
});
// router.beforeEach((to, from, next) => {
//     if (store.getters.isLoggedIn) {
//         const user = store.getters.getLoggedUser;
//         console.log(user);
//         if (!to.meta.adminAuth) {
//             if (!user.role) {
//                 next({ name: 'profile' });
//             } else {
//                 next();
//             }
//         } else {
//             next();
//         }
//     } else {
//         next();
//     }
// });

export default router;
